import { createApp } from 'vue';
import ArcoVue from '@arco-design/web-vue';
import ArcoVueIcon from '@arco-design/web-vue/es/icon';
import '@arco-design/web-vue/dist/arco.css';
import { createPinia } from 'pinia';
import App from './App.vue';
import { createAppRouter } from './router';
import { useSiteStore } from './stores/site';
import './styles/tokens.css';
import './styles/global.css';

async function bootstrap() {
  const app = createApp(App);
  const pinia = createPinia();
  app.use(pinia);
  const site = useSiteStore(pinia);
  await site.load();
  const router = createAppRouter(site.settings.adminPath);
  app.use(router).use(ArcoVue).use(ArcoVueIcon);
  await router.isReady();
  app.mount('#app');
}

void bootstrap().catch((error: unknown) => {
  console.error('Application bootstrap failed', error);
  const root = document.querySelector<HTMLElement>('#app');
  if (root) root.textContent = '页面加载失败，请刷新后重试。';
});
